/**
 * Adjusts the canvas size to match the display size if needed.
 *
 * @param {HTMLCanvasElement} canvas - The canvas element to resize.
 * @return {Object|boolean} An object with the new width and height if resized; otherwise, returns false.
 */
export const resizeCanvasToDisplaySize = (canvas) => {
    const { width, height } = canvas.getBoundingClientRect();

    if (canvas.width !== width || canvas.height !== height) {
        canvas.width = width;
        canvas.height = height;
        return { width, height };
    }

    return false;
}

/**
 * Ensures consistent display of a canvas element across devices by resizing
 * it based on device pixel ratio, providing better clarity on high DPI devices.
 *
 * @param {HTMLCanvasElement} canvas - The canvas element to adjust.
 * @return {boolean} Returns true if the canvas size is adjusted; otherwise, returns false.
 */
export const resizeCanvas = (canvas) => {
    const { width, height } = canvas.getBoundingClientRect();
    if (canvas.width !== width || canvas.height !== height) {
        const { devicePixelRatio: ratio = 1 } = window;
        const context = canvas.getContext('2d');

        canvas.width = width * ratio;
        canvas.height = height * ratio;
        context.scale(ratio, ratio);

        return true;
    }

    return false;
}

